import { Divider, PageHeadline } from 'components/elements';
import { useFind } from 'components/hooks';
import { ReadOnly } from 'components/modules';
import fp from 'lodash/fp';
import { useTranslation } from 'react-i18next';
import { useMount } from 'react-use';
import { CompanyTypeResources } from 'services/resources/catalogs/company-type';
import { IReadOnlyResource } from 'services/resources/catalogs/types.d';

export const CompanyTypePage: React.FC = (): JSX.Element => {
  const [state, onFind] = useFind<IReadOnlyResource>(CompanyTypeResources);

  const { t } = useTranslation('common');

  useMount(() => onFind());

  return (
    <>
      <PageHeadline
        quote={t('page.read-only.quote')}
        title={t('page.company-type.title')}
      />

      <Divider />

      <ReadOnly data={fp.get(['value', 'results'])(state)} m={8} />
    </>
  );
};
